import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { id: "basic" }
const _hoisted_2 = { class: "optionsBox" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "title" }, "本地存储", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "about" }, "将您的设置存储在浏览器缓存中", -1)
const _hoisted_5 = { class: "operation" }
const _hoisted_6 = { class: "optionsBox" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "title" }, "底部文案", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "about" }, "是否展示底部文案", -1)
const _hoisted_9 = { class: "operation" }
const _hoisted_10 = { class: "optionsBox" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "title" }, "一言", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "about" }, "是否加载一言", -1)
const _hoisted_13 = { class: "operation" }
const _hoisted_14 = { class: "optionsBox" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "title" }, "一言类型", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { class: "about" }, "选择一言的类型", -1)
const _hoisted_17 = { class: "operation" }
const _hoisted_18 = { class: "btns" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("恢复默认")
const _hoisted_20 = { class: "optionsBox" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", { class: "title" }, "网址导航", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", { class: "about" }, "是否开启网址导航", -1)
const _hoisted_23 = { class: "operation" }

import data from "@/data/data";
import notify from "@/utils/notify/notify";
import local from "@/utils/localData/local";
import { RefreshLeft } from "@element-plus/icons-vue";

/**
 * 一言类型修改
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'basic',
  setup(__props) {

function changeHitokoto() {
    let length = data.saveData.hitokotoIndex.length;
    // 最后一项时则缓存
    if (length == 1) {
        return (data.saveData.hitokotoLastData =
            data.saveData.hitokotoIndex[0]);
    }
    // 选择了其他时不选择默认选项
    if (length > 1 && data.saveData.hitokotoIndex.includes("all")) {
        notify("点击恢复默认即可随机", 3);
        data.saveData.hitokotoIndex.splice(
            data.saveData.hitokotoIndex.indexOf("all"),
            1
        );
    }
    // 只有最后一项时无法移除
    if (length == 0) {
        notify("至少得选择一个哦~", 2);
        data.saveData.hitokotoIndex.push(data.saveData.hitokotoLastData);
    }
}

/**
 * 一言恢复默认
 */
function reloadHitokoto() {
    data.saveData.hitokotoIndex = ["all"];
    notify("一言已恢复默认类型", 1);
}

/**
 * 保存配置并提示
 */
function saveAndNotify(msg: Array<string>, type: boolean) {
    notify(type ? msg[0] : msg[1], type ? 1 : 3);
    local.save();
}

return (_ctx: any,_cache: any) => {
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_el_switch, {
          modelValue: _unref(data).saveData.updateStorage,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(data).saveData.updateStorage) = $event)),
          "active-color": "#13ce66",
          onChange: _cache[1] || (_cache[1] = ($event: any) => (
                        saveAndNotify(
                            [
                                '已开启本地存储设置',
                                '已关闭本地存储设置，设置里面还可以开启哦'
                            ],
                            _unref(data).saveData.updateStorage
                        )
                    ))
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_el_switch, {
          modelValue: _unref(data).saveData.footerText,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(data).saveData.footerText) = $event)),
          "active-color": "#13ce66",
          onChange: _cache[3] || (_cache[3] = ($event: any) => (
                        saveAndNotify(
                            ['已开启底部文案展示', '已关闭底部文案展示'],
                            _unref(data).saveData.footerText
                        )
                    ))
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _hoisted_11,
      _hoisted_12,
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_el_switch, {
          modelValue: _unref(data).saveData.hitokotoShow,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(data).saveData.hitokotoShow) = $event)),
          "active-color": "#13ce66",
          onChange: _cache[5] || (_cache[5] = ($event: any) => (
                        saveAndNotify(
                            ['已开启一言', '已关闭一言'],
                            _unref(data).saveData.hitokotoShow
                        )
                    ))
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _hoisted_15,
      _hoisted_16,
      _createElementVNode("div", _hoisted_17, [
        _createVNode(_component_el_select, {
          modelValue: _unref(data).saveData.hitokotoIndex,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(data).saveData.hitokotoIndex) = $event)),
          multiple: "",
          onChange: changeHitokoto
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).hitokotoConfig, (item) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: item[1],
                label: item[0],
                value: item[1]
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createVNode(_component_el_button, {
          type: "primary",
          size: "small",
          icon: _unref(RefreshLeft),
          onClick: reloadHitokoto
        }, {
          default: _withCtx(() => [
            _hoisted_19
          ]),
          _: 1
        }, 8, ["icon"])
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _hoisted_21,
      _hoisted_22,
      _createElementVNode("div", _hoisted_23, [
        _createVNode(_component_el_switch, {
          modelValue: _unref(data).saveData.openAppListShow,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(data).saveData.openAppListShow) = $event)),
          "active-color": "#13ce66",
          onChange: _cache[8] || (_cache[8] = ($event: any) => (
                        saveAndNotify(
                            ['网址导航已开启', '网址导航已关闭'],
                            _unref(data).saveData.openAppListShow
                        )
                    ))
        }, null, 8, ["modelValue"])
      ])
    ])
  ]))
}
}

})